import React from 'react';
import { Formik } from 'formik';

import InputContainer from '@RHEnvironmental/pattern-library/dist/js/components/InputContainer';
import InputLabel from '@RHEnvironmental/pattern-library/dist/js/components/InputLabel';
import SelectBox from '@RHEnvironmental/pattern-library/dist/js/components/SelectBox';

import { useDispatch } from 'react-redux';
import role from '../../../services/ui/role';
import officerApi from '../../../services/api/officerApi';
import { setAlert } from '../../../actions/alerts';

const Officer = ({ onSuccess, officer, roles, sessionUser }) => {
    const dispatch = useDispatch();

    const initialFormValues = {
        role_id: role.forOfficer(officer).id,
    };

    const initialFormStatus = {
        errorMessage: null,
    };

    const onSubmit = async (roleId, setStatus, setSubmitting) => {
        if (sessionUser.id === officer.id) {
            dispatch(
                setAlert(
                    'You cannot change your own role.',
                    'error',
                    'settings'
                )
            );
            return;
        }
        try {
            setSubmitting(true);

            await officerApi.update(officer.id, { role_id: roleId });

            dispatch(setAlert('Officer role updated.', 'success', 'settings'));
            onSuccess();
        } catch ({ response }) {
            dispatch(
                setAlert(
                    'There was a problem updating the officer details.',
                    'error',
                    'settings'
                )
            );
        } finally {
            setSubmitting(false);
        }
    };

    return (
        <Formik
            onSubmit={onSubmit}
            initialValues={initialFormValues}
            initialStatus={initialFormStatus}
        >
            {({
                values,
                handleSubmit,
                isSubmitting,
                setStatus,
                setSubmitting,
                resetForm,
            }) => (
                <form onSubmit={handleSubmit}>
                    <InputContainer>
                        <InputLabel htmlFor="role_id" show>
                            Role
                        </InputLabel>
                        <SelectBox
                            disabled={isSubmitting}
                            name="role_id"
                            controlFunc={(e) =>
                                onSubmit(
                                    e.target.value,
                                    setStatus,
                                    setSubmitting,
                                    resetForm
                                )
                            }
                        >
                            {roles.map((role, index) => (
                                <option
                                    selected={values.role_id === role.id}
                                    value={role.id}
                                    key={index}
                                >
                                    {role.name}
                                </option>
                            ))}
                        </SelectBox>
                    </InputContainer>
                </form>
            )}
        </Formik>
    );
};

export default Officer;
